import { SalesforceBase } from './salesforce-base.model';
import { Account } from './account.model';
import { ComponentRecords } from './nitel-component.model';
import { Element } from './element.model';
import { Location } from './location.model';
import { User } from './user.model';
import { Order } from './order.model';

export interface Service extends SalesforceBase {
  alias: any;
  Vendor__r?: any;
  localContacts?: string;
  Account__r?: Account;
  Activation_Date__c?: Date;
  Activation_Pending__c?: boolean;
  Asymmetrical_Bandwidth__c?: boolean;
  Bandwidth_Downstream__c?: string;
  Bandwidth_Upstream__c?: string;
  BanLookupId?: string;
  Booked_MRM__c?: number;
  Clean_Order_Date__c?: Date;
  Components__r?: ComponentRecords;
  Connector_Type_Z_Location__c?: string;
  Current_Term_End_Date__c?: Date;
  CustomerLocationAlias?: string;
  Elements__r?: Element[];
  End_Of_Service__c?: Date;
  First_Invoice__c?: Date;
  MRR__c?: number;
  Orders__r: Order[];
  Partner_MRC_Percentage__c?: number;
  Partner_MRC__c?: number;
  Partner_Or_Subagent_Rep__r?: User;
  Partner__r?: SalesforceBase;
  RecordType?: SalesforceBase;
  Sales_Rep__r?: User;
  Start_Of_Service__c?: Date;
  Status__c?: string;
  Term__c?: string;
  Transport_Type__c: string;
  TSP_Code__c?: string;
  Z_Location_Company_Name__c?: string;
  Z_Location_Customer_Side_Id__c?: string;
  Z_Location__c?: string;
  Z_Location__r?: Location;
}

export interface MappedDisconnectService {
  id: string;
  nit: string;
  product: string;
  locationId: string;
  locationName: string;
  disabled: boolean;
}

export enum ServiceStatus {
  InService = 'InService',
  New = 'New',
  Canceled = 'Canceled',
  Disconnected = 'Disconnected',
}
